const DefaultSymbol = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.374023" y="0.501953" width="13.2593" height="13.2593" rx="6.62964" fill="#D9D9D9" />
        </svg>
    );
};

export default DefaultSymbol;
